import { logger as createLogger } from '#utils/logger'

export const shortcutLogger = createLogger('⏩ Shortcut Context:')
